export default function($) {
  $('.js-documents-trigger').on('click', function() {
    $(this).siblings('.js-documents-wrapper').slideToggle();
  })
}
